import { render, staticRenderFns } from "./DailyEmailBlock.vue?vue&type=template&id=7e4b9164&scoped=true&"
import script from "./DailyEmailBlock.vue?vue&type=script&lang=js&"
export * from "./DailyEmailBlock.vue?vue&type=script&lang=js&"
import style0 from "./DailyEmailBlock.vue?vue&type=style&index=0&id=7e4b9164&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b9164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4b9164')) {
      api.createRecord('7e4b9164', component.options)
    } else {
      api.reload('7e4b9164', component.options)
    }
    module.hot.accept("./DailyEmailBlock.vue?vue&type=template&id=7e4b9164&scoped=true&", function () {
      api.rerender('7e4b9164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DailyEmail/DailyEmailBlock.vue"
export default component.exports